import { useState } from 'react';

type ElectronicClientRecordAlertAccordion = {
  isExpanded: boolean;
  toggleExpansion: () => void;
};

const useElectronicClientRecordAlertAccordion = (): ElectronicClientRecordAlertAccordion => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const toggleExpansion = (): void => setIsExpanded(!isExpanded);

  return {
    isExpanded,
    toggleExpansion,
  };
};

export default useElectronicClientRecordAlertAccordion;
